import Script from 'next/script'
import { FunctionComponent } from 'react'

const MazeScript: FunctionComponent = () => {
  return (
    <Script id='mazeScript' strategy='beforeInteractive'>
      {`
          (function (m, a, z, e) {
            var s, t;
            try {
              t = m.sessionStorage.getItem('maze-us');
            } catch (err) {}
          
            if (!t) {
              t = new Date().getTime();
              try {
                m.sessionStorage.setItem('maze-us', t);
              } catch (err) {}
            }
          
            s = a.createElement('script');
            s.src = z + '?apiKey=' + e;
            s.async = true;
            a.getElementsByTagName('head')[0].appendChild(s);
            m.mazeUniversalSnippetApiKey = e;
          })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', '9074aaf8-15ee-4b7b-89b1-9b6f759dd2bb');
        `}
    </Script>
  )
}

export default MazeScript
